// client/constants/academyApi.js
import api from "./api.js";

const A = "/academy";

export const AcademyAPI = {
  status: () => api.get(`${A}/status`, { silent: true }).then((r) => r.data),
  catalog: (params = {}) => api.get(`${A}/catalog`, { params }).then((r) => r.data),
  lesson: (id) => api.get(`${A}/lessons/${id}`).then((r) => r.data),
  completeLesson: (id) => api.post(`${A}/lessons/${id}/complete`).then((r) => r.data),
  checklistItem: (id, body) => api.post(`${A}/lessons/${id}/checklist`, body).then((r) => r.data),
  complete: () => api.post(`${A}/complete`).then((r) => r.data),
  event: (body) => api.post(`${A}/events`, body, { silent: true }).then((r) => r.data),
  context: (key) => api.get(`${A}/context/${encodeURIComponent(key)}`, { silent: true }).then((r) => r.data),

  adminTracks: () => api.get(`${A}/admin/tracks`).then((r) => r.data),
  adminCreateTrack: (body) => api.post(`${A}/admin/tracks`, body).then((r) => r.data),
  adminUpdateTrack: (id, body) => api.put(`${A}/admin/tracks/${id}`, body).then((r) => r.data),

  adminModules: (params = {}) => api.get(`${A}/admin/modules`, { params }).then((r) => r.data),
  adminCreateModule: (body) => api.post(`${A}/admin/modules`, body).then((r) => r.data),
  adminUpdateModule: (id, body) => api.put(`${A}/admin/modules/${id}`, body).then((r) => r.data),

  adminLessons: (params = {}) => api.get(`${A}/admin/lessons`, { params }).then((r) => r.data),
  adminCreateLesson: (body) => api.post(`${A}/admin/lessons`, body).then((r) => r.data),
  adminUpdateLesson: (id, body) => api.put(`${A}/admin/lessons/${id}`, body).then((r) => r.data),
  adminPublishLesson: (id) => api.post(`${A}/admin/lessons/${id}/publish`).then((r) => r.data),
  adminUnpublishLesson: (id) => api.post(`${A}/admin/lessons/${id}/unpublish`).then((r) => r.data),

  adminUserProgress: (userId) => api.get(`${A}/admin/users/${userId}/progress`).then((r) => r.data),
  adminResetUser: (userId, body = {}) => api.post(`${A}/admin/users/${userId}/reset`, body).then((r) => r.data),
  adminWaiveUser: (userId, body = {}) => api.post(`${A}/admin/users/${userId}/waive`, body).then((r) => r.data),
  adminAnalytics: () => api.get(`${A}/admin/analytics`).then((r) => r.data),
};
